import { inject, injectable } from 'inversify'
import symbols from '../../symbols'
import {
  AddAngelInvitationUseCaseInput,
  AddAngelInvitationUseCaseOutput,
  IAddAngelInvitationUseCase,
  IAppErrorFactory,
  IInvitationsService,
} from '../../types'

@injectable()
export default class AddAngelInvitationInteractor implements IAddAngelInvitationUseCase {
  @inject(symbols.IInvitationsService) private invitationsService: IInvitationsService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: AddAngelInvitationUseCaseInput): Promise<AddAngelInvitationUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      output.invitationLink = await this.invitationsService.addAngelInvitation(input)
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    return output
  }

  private getDefaultOutputData(): AddAngelInvitationUseCaseOutput {
    return {
      invitationLink: null,
      error: null,
    }
  }
}
